<template>
  <div class="content-container">
    <search-comp @onSearch="attachData" @onReset="onReset">
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Số hóa đơn</div>
                <div class="child-w-80">
                  <input v-model="searchParams.invoiceNum" type="text" />
                </div>
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Mã đặt phòng</div>
                <div class="child-w-80">
                  <input v-model="searchParams.recode" type="text" />
                </div>
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Khách sạn</div>
                <div class="child-w-80">
                  <el-select
                    v-model="searchParams.hotelIds"
                    multiple
                    collapse-tags
                  >
                    <el-option
                      v-for="(hotel, index) in hotelList"
                      :key="index"
                      :value="hotel.id"
                      :label="hotel.name"
                    ></el-option>
                  </el-select>
                </div>
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Công ty/ Đại lý</div>
                <div class="child-w-80">
                  <el-select
                    v-model="searchParams.agentId"
                    clearable
                    filterable
                    collapse-tags
                  >
                    <el-option
                      v-for="(item, index) in agentOptions"
                      :key="index"
                      :value="item.id"
                      :label="`(${item.code}) ${item.name || ''}`"
                    ></el-option>
                  </el-select>
                </div>
              </div>
            </div>
          </div>
          <div class="das-form-row">
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Tài khoản lễ tân</div>
                <div class="child-w-80">
                  <!-- :date-data="agentItem.representative_card_date" -->
                  <!-- v-model="agentItem.representative_card_date" -->
                  <!-- @changeCalendar="onChangeDate2" -->
                  <select-with-search-table
                    :key="dataKey"
                    style="width: 100%"
                    :rows="FOAgentOptions"
                    :columns="columnsFOAgent"
                    index-field="id"
                    :selected-index-field-value="searchParams.accountId"
                    :value="searchParams.accountId"
                    :dropdown-width="400"
                    @selectionChanged="onSelectRowAgent"
                  >
                    <template v-slot:value="{ selectedValue: selectedData }">
                      {{ selectedData?.full_name }}
                    </template>
                  </select-with-search-table>
                </div>
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Ngày</div>
                <div class="child-w-80">
                  <!-- :date-data="agentItem.representative_card_date" -->
                  <!-- v-model="agentItem.representative_card_date" -->
                  <!-- @changeCalendar="onChangeDate2" -->
                  <CalendarRange
                    v-model="datetimeRange"
                    style="display: block; width: 500px"
                    mode="date"
                    :disabled="disabledDate"
                    @input="setDateRange"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </search-comp>
    <div class="content-box">
      <div class="section-box outline">
        <div class="das-form-container">
          <div class="das-form-title-container justify-space-between">
            <div class="das-form-title">
              <span class="main-title">Báo cáo thu tiền theo hóa đơn</span>
            </div>
            <div class="button-containers-title">
              <InfoBtn @click="dialogFormVisible = true" />
              <el-dropdown trigger="click" @command="handleCommand">
                <button class="btn medium primary outline download-button">
                  <i class="el-icon-download"></i>
                </button>
                <el-dropdown-menu>
                  <el-dropdown-item command="pdf">Xuất PDF</el-dropdown-item>
                  <el-dropdown-item command="excel"
                    >Xuất Excel</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
              <!-- <button class="btn primary small">Xuất Excel</button> -->
            </div>
            <!-- <button class="btn medium primary outline">Thêm</button> -->
          </div>
          <hr />
          <div v-loading="loading" class="grid-scroll mt-10">
            <GridVx
              ref="agGrid"
              :columns="columns"
              :rows="rows"
              class="agGrid"
              :header-height-setter="headerHeightSetter"
              :is-header-height-setter="true"
              :default-col-def="defaultColDef"
              :auto-select-first-row="false"
              :auto-size-cell="true"
              dom-layout="scroll"
              row-selection="false"
            />
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      title="Chú thích"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="500px"
    >
      <div class="das-form-container">
        <div class="das-form-group">
          <ul class="annotate-container">
            <li>
              Số hóa đơn: Khi phhát sinh giao dịch và có thanh toán => có hóa
              đơn => hiển thị thông tin từng hóa đơn
            </li>
            <li>Recode: Mã đặt phòng</li>
            <li>Nguồn: Hiển thị Tên nguồn của đặt phòng</li>
            <li>Ngày đến/Ngày đi: Hiển thị theo format DDMMYYYY - DDMMYYYY</li>
            <li>
              Ngày tạo hóa đơn: Hiển thị ngày tạo hóa đơn. Format : DDMMYYYY
              HHMMSS
            </li>
            <li>Số tiền trên hóa đơn: Hiển thị số tiền trên hóa đơn</li>
            <li>
              Thanh toán: Hiển thị danh sách các phương thức thanh toán được cấu
              hình
            </li>
            <li>
              Lễ tân: Hiển thị tài khoản lễ tân tạo thanh toán cho giao dịch
              phòng
            </li>
            <li>
              Thu ngân: Hiển thị tài khoản thu ngân tạo thanh toán cho các giao
              dịch tại nhà hàng
            </li>
            <li>
              Tổng: tổng doanh thu của từng loại dịch vụ, thuộc tất cá các hóa
              đơn thuộc phòng và nhà hàng bao gồm cả phí dịch vụ (Đối với nhà
              hàng) và thuế (không tính vé)
            </li>
          </ul>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button class="btn primary small" @click="dialogFormVisible = false">
            {{ $t('button.cancel') }}
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import { getSourceApi } from '@/api/Statistics/source'
import SelectWithSearchTable from '@/components/inputs/SelectWithSearchTable.vue'
import { getAllHotel } from '@/api/hotel'
import {
  getListMoneybyInvoiceReport,
  getAllFO,
  getListMoneybyInvoiceReportExcel,
  getAgentListForReport
} from '@/api/report_service/takeMoneybyInvoice'
import { ViewInvoiceCellRender } from '@/utils/cellRenders'

import CalendarSelect from '@/components/CalendarSelect/CalendarSelect.vue'
import CalendarRange from '@/components/CalendarSelect/CalendarRange.vue'

import InfoBtn from './components/InfoBtn.vue'
import { downFile } from '@/utils/file-handler'
import { getFileNm } from '@/utils/file-name-helper'

export default {
  components: {
    CalendarSelect,
    CalendarRange,
    SelectWithSearchTable,
    InfoBtn,
    ViewInvoiceCellRender
  },
  data() {
    return {
      dataKey: 0,
      disabledDate: false,
      defaultColDef: {
        flex: 1,
        // resizable: true,
        // sortable: true,
        suppressMovable: true,
        wrapText: true,
        autoHeight: true,
        headerComponentParams: {
          template:
            '<div class="ag-cell-label-container" role="presentation">' +
            '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
            '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
            // '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order"></span>' +
            // '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon"></span>' +
            // '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon"></span>' +
            // '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon"></span>' +
            '    <span ref="eText" class="ag-header-cell-text" role="columnheader" style="white-space: normal;"></span>' +
            // '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
            '  </div>' +
            '</div>'
        }
      },
      defaultDatetimeRange: {
        start: this.$moment().format('YYYY-MM-DD'),
        end: this.$moment().format('YYYY-MM-DD')
      },
      datetimeRange: {
        start: this.$moment().format('YYYY-MM-DD'),
        end: this.$moment().format('YYYY-MM-DD')
      },
      dialogFormVisible: false,
      hotelList: [],
      loading: false,
      searchParams: {
        invoiceNum: null,
        date: this.$moment().format('YYYY-MM-DD'),
        dateTo: this.$moment().format('YYYY-MM-DD'),
        recode: null,
        hotelIds: [],
        accountId: null,
        agentId: null
      },
      defaultSearchParams: {
        invoiceNum: null,
        date: this.$moment().format('YYYY-MM-DD'),
        dateTo: this.$moment().format('YYYY-MM-DD'),
        recode: null,
        hotelIds: [],
        accountId: null,
        agentId: null
      },
      FOAgentOptions: [],
      agentOptions: [],
      columnsFOAgent: [
        {
          headerName: 'ID Nhân viên',
          field: 'code',
          minWidth: 150,
          maxWidth: 150
        },
        {
          headerName: 'Họ và tên',
          field: 'full_name',
          flex: 1
        }
      ],

      columns: [
        {
          headerName: 'Nhóm/Khách đoàn',
          field: 'group_code',
          tooltipField: 'group_code',
          cellRenderer: 'ViewInvoiceCellRender',

          // cellClass: "grid-cell-centered",
          // width: 100,
          sortable: false,
          minWidth: 130
        },
        {
          headerName: this.$t('grid.column.invoiceNumber'),
          field: 'invoice_num',
          tooltipField: 'invoice_num',
          // cellClass: "grid-cell-centered",
          // width: 100,
          sortable: false,
          minWidth: 130
        },
        {
          headerName: this.$t('grid.column.bookingCode'),
          field: 'recode',
          tooltipField: 'recode',

          // cellClass: "grid-cell-centered",
          sortable: false,
          minWidth: 110
        },
        {
          headerName: 'Công ty đại lý du lịch',
          field: 'agent_name',
          tooltipField: 'agent_name',
          // cellClass: "grid-cell-centered",
          // width: 100,
          sortable: false,
          minWidth: 120
          // maxWidth: 120
        },
        {
          headerName: this.$t('grid.column.source'),
          field: 'source',
          tooltipField: 'source',
          // cellClass: "grid-cell-centered",
          // width: 100,
          sortable: false,
          minWidth: 120
          // maxWidth: 120
        },

        {
          headerName: this.$t('grid.column.createInvoiceDate'),
          field: 'create_date',
          tooltipField: 'create_date',
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          minWidth: 180,
          maxWidth: 180,
          cellStyle: params => {
            if (params.node.lastChild) {
              return {
                display: 'flex',
                'align-items': 'center',
                'text-wrap': 'nowrap',
                'font-weight': 600,
                overflow: 'visible'
              }
            }
          }
          // cellClass: "grid-cell-centered",
        },
        {
          headerName: this.$t('grid.column.amountOfMoneyInvoice'),
          field: 'money',
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          tooltipValueGetter: params => {
            if (params.value !== null && params.value !== undefined) {
              return Number(params.value).toLocaleString('en')
            }
            return null
          },
          // cellClass: "grid-cell-centered",
          valueFormatter: params => {
            if (params.value !== null && params.value !== undefined) {
              return Number(params.value).toLocaleString('en')
            }
            return null
          },
          minWidth: 120
          // cellClass: "grid-cell-centered",
        },
        {
          headerName: this.$t('grid.column.payment'),
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          headerClass: [
            'header-cell-suffix-group',
            'header-group-cell-divide',
            'header-group-cell-divide-right',
            'header-cell-center'
          ],
          // maxWidth: 200,
          marryChildren: true,
          // cellClass: "grid-cell-centered",
          children: [
            {
              headerName: this.$t('grid.column.card'),
              field: 'card',
              // cellRenderer: 'CellRenderTextInput',
              sortable: false,
              tooltipValueGetter: params => {
                if (params.value !== null && params.value !== undefined) {
                  return Number(params.value).toLocaleString('en')
                } else {
                  return null
                }
              },
              // cellClass: "grid-cell-centered",
              valueFormatter: params => {
                if (params.value !== null && params.value !== undefined) {
                  return Number(params.value).toLocaleString('en')
                } else {
                  return null
                }
              },
              minWidth: 90,
              cellStyle: params => {
                if (params.node.lastChild) {
                  return {
                    display: 'flex',
                    'align-items': 'center',
                    'text-wrap': 'nowrap',
                    'font-weight': 600,
                    overflow: 'visible'
                  }
                }
              }
              // cellClass: "grid-cell-centered",
            },
            {
              headerName: this.$t('grid.column.bankingTransfer'),
              field: 'transfer',
              // cellRenderer: 'CellRenderTextInput',
              sortable: false,
              tooltipValueGetter: params => {
                if (params.value !== null && params.value !== undefined) {
                  return Number(params.value).toLocaleString('en')
                } else {
                  return null
                }
              },

              // cellClass: "grid-cell-centered",
              valueFormatter: params => {
                if (params.value !== null && params.value !== undefined) {
                  return Number(params.value).toLocaleString('en')
                } else {
                  return null
                }
              },
              minWidth: 100,
              cellStyle: params => {
                if (params.node.lastChild) {
                  return {
                    display: 'flex',
                    'align-items': 'center',
                    'text-wrap': 'nowrap',
                    'font-weight': 600,
                    overflow: 'visible'
                  }
                }
              }
              // cellClass: "grid-cell-centered",
            },
            {
              headerName: this.$t('grid.column.debt'),
              field: 'debt',
              // cellRenderer: 'CellRenderTextInput',
              sortable: false,
              tooltipValueGetter: params => {
                if (params.value !== null && params.value !== undefined) {
                  return Number(params.value).toLocaleString('en')
                } else {
                  return null
                }
              },
              // cellClass: "grid-cell-centered",
              valueFormatter: params => {
                if (params.value !== null && params.value !== undefined) {
                  return Number(params.value).toLocaleString('en')
                } else {
                  return null
                }
              },
              minWidth: 100,
              cellStyle: params => {
                if (params.node.lastChild) {
                  return {
                    display: 'flex',
                    'align-items': 'center',
                    'text-wrap': 'nowrap',
                    'font-weight': 600,
                    overflow: 'visible'
                  }
                }
              }
              // cellClass: "grid-cell-centered",
            },
            {
              headerName: this.$t('grid.column.free'),
              field: 'free',
              // cellRenderer: 'CellRenderTextInput',
              sortable: false,
              tooltipValueGetter: params => {
                if (params.value !== null && params.value !== undefined) {
                  return Number(params.value).toLocaleString('en')
                } else {
                  return null
                }
              },
              // cellClass: "grid-cell-centered",
              valueFormatter: params => {
                if (params.value !== null && params.value !== undefined) {
                  return Number(params.value).toLocaleString('en')
                } else {
                  return null
                }
              },
              minWidth: 100,
              cellStyle: params => {
                if (params.node.lastChild) {
                  return {
                    display: 'flex',
                    'align-items': 'center',
                    'text-wrap': 'nowrap',
                    'font-weight': 600,
                    overflow: 'visible'
                  }
                }
              }
              // cellClass: "grid-cell-centered",
            },
            {
              headerName: this.$t('grid.column.cash'),
              field: 'cash',
              // cellRenderer: 'CellRenderTextInput',
              sortable: false,
              tooltipValueGetter: params => {
                if (params.value !== null && params.value !== undefined) {
                  return Number(params.value).toLocaleString('en')
                } else {
                  return null
                }
              },
              // cellClass: "grid-cell-centered",
              valueFormatter: params => {
                if (params.value !== null && params.value !== undefined) {
                  return Number(params.value).toLocaleString('en')
                } else {
                  return null
                }
              },
              minWidth: 100,
              cellStyle: params => {
                if (params.node.lastChild) {
                  return {
                    display: 'flex',
                    'align-items': 'center',
                    'text-wrap': 'nowrap',
                    'font-weight': 600,
                    overflow: 'visible'
                  }
                }
              }

              // cellClass: "grid-cell-centered",
            },
            {
              headerName: this.$t('grid.column.deposit'),
              field: 'deposit',
              // cellRenderer: 'CellRenderTextInput',
              sortable: false,
              tooltipValueGetter: params => {
                if (params.value !== null && params.value !== undefined) {
                  return Number(params.value).toLocaleString('en')
                } else {
                  return null
                }
              },
              // cellClass: "grid-cell-centered",
              valueFormatter: params => {
                if (params.value !== null && params.value !== undefined) {
                  return Number(params.value).toLocaleString('en')
                } else {
                  return null
                }
              },
              minWidth: 100,
              cellStyle: params => {
                if (params.node.lastChild) {
                  return {
                    display: 'flex',
                    'align-items': 'center',
                    'text-wrap': 'nowrap',
                    'font-weight': 600,
                    overflow: 'visible'
                  }
                }
              }

              // cellClass: "grid-cell-centered",
            }
          ]
        },

        {
          headerName: this.$t('grid.column.receptionist'),
          field: 'reception',
          tooltipField: 'reception',
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          minWidth: 150
          // cellClass: "grid-cell-centered",
        },
        {
          headerName: this.$t('grid.column.cashier'),
          field: 'cashier',
          tooltipField: 'cashier',
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          minWidth: 150
          // cellClass: "grid-cell-centered",
        }
      ],
      rows: []
    }
  },
  computed: {
    invoiceNum() {
      return this.searchParams.invoiceNum
    }
  },
  watch: {
    invoiceNum: {
      handler(val) {
        // console.log(val, 'new', 'old')
        if (val) {
          this.disabledDate = true
          this.datetimeRange = {
            start: null,
            end: null
          }
          this.searchParams.date = null
          this.searchParams.dateTo = null
        } else {
          this.disabledDate = false
          this.datetimeRange = {
            start: this.$moment().format('YYYY-MM-DD'),
            end: this.$moment().format('YYYY-MM-DD')
          }
          this.searchParams.date = this.$moment().format('YYYY-MM-DD')
          this.searchParams.dateTo = this.$moment().format('YYYY-MM-DD')
        }
      },
      deep: true
    }
  },
  created() {
    this.getListHotel()
    this.getListFOAccount()
    this.fnGetAgentOptions()
  },
  mounted() {
    this.attachData()
  },
  methods: {
    handleCommand(cmmd) {
      // this.$message('click on item ' + cmmd)
      switch (cmmd) {
        case 'pdf':
          break
        case 'excel':
          this.downloadExcel()
          break
        default:
          this.$message('click on item ' + cmmd)
          break
      }
    },
    setDateRange(range) {
      // console.log(range.start, range.end)

      this.searchParams.date = range.start
      this.searchParams.dateTo = range.end
    },
    async fnGetAgentOptions() {
      const data = await getAgentListForReport()
      this.agentOptions = [{ id: null, code: 'Tất cả' }, ...data.data] || []
    },
    async getListHotel() {
      const data = await getAllHotel()
      this.hotelList = data.data
    },
    async getListFOAccount() {
      const data = await getAllFO()
      this.FOAgentOptions = data.data.map(item => item?.account)
    },
    onSelectRowAgent(val) {
      this.searchParams.saleAgentId = val.id
    },
    headerHeightGetter() {
      var columnHeaderTexts = [
        ...document.querySelectorAll('.ag-header-cell-text')
      ]
      var clientHeights = columnHeaderTexts.map(
        headerText => headerText.clientHeight
      )
      var tallestHeaderTextHeight = Math.max(...clientHeights)

      return tallestHeaderTextHeight
    },
    headerHeightSetter() {
      var padding = 30
      var height = this.headerHeightGetter() / 2 + padding
      this.$refs.agGrid.gridApi.setHeaderHeight(height)
      this.$refs.agGrid.gridApi.resetRowHeights()
    },
    async attachData() {
      try {
        this.loading = true

        const data = await getListMoneybyInvoiceReport(this.searchParams)
        this.loading = false
        if (data.data?.transactions?.length > 0) {
          this.rows = [
            ...data.data?.transactions,
            {
              create_date: 'Tổng',
              card: data.data.card_total,

              transfer: data.data.transfer_total,
              debt: data.data.debt_total,
              free: data.data.free_total,
              cash: data.data.cash_total,
              deposit: data.data.deposit_total,
              rowHeightTotal: true
            }
          ]
        } else {
          this.rows = []
        }
      } catch (error) {
        this.$message({
          type: 'error',
          message: this.$t(
            'errorMsg.' + error?.response?.data?.message
              ? error?.response?.data?.message
              : error
          )
        })
      } finally {
        this.loading = false
      }
    },
    async downloadExcel() {
      try {
        this.loading = true

        const data = await getListMoneybyInvoiceReportExcel(this.searchParams)
        this.loading = false

        downFile(data, 'bao_cao_thu_tien_theo_hoa_don.xlsx')
        // downFile(data, )
      } catch (error) {
        this.$message({
          type: 'error',
          message: this.$t(
            'errorMsg.' + error?.response?.data?.message
              ? error?.response?.data?.message
              : 'default'
          )
        })
      } finally {
        this.loading = false
      }
    },

    onReset() {
      this.dataKey++
      this.datetimeRange = { ...this.defaultDatetimeRange }
      this.searchParams = { ...this.defaultSearchParams }
      this.attachData()
    }
  }
}
</script>

<style lang="scss">
.button-containers-title {
  display: flex;
  /* margin-top: 20px; */
  justify-content: flex-end;
  align-items: flex-end;
  gap: 10px;
  .download-button {
    padding: 10px 10px;
  }
}
.ag-cell-wrapper {
  top: auto !important;
}
</style>
